const orNA = (value) => {
  const text = String(value || "").trim();
  return text || "N/A";
};

export const formatBornLine = (bio = {}) => {
  const bornOn = String(bio.bornOn || "").trim();
  const bornIn = String(bio.bornIn || "").trim();
  if (bornOn && bornIn) return `${bornOn} in ${bornIn}`;
  return bornOn || bornIn || "N/A";
};

export const formatDiedLine = (bio = {}) => {
  const diedOn = String(bio.diedOn || "").trim();
  if (!diedOn) return null;
  const diedIn = String(bio.diedIn || "").trim();
  return diedIn ? `${diedOn} in ${diedIn}` : diedOn;
};

const optionalLine = (label, value) => {
  const text = String(value || "").trim();
  return text ? { label, value: text } : null;
};

const splitAtLabel = (value, label) => {
  const text = String(value || "");
  const pattern = new RegExp(`\\s*${label}:\\s*`, "i");
  const index = text.search(pattern);
  if (index < 0) {
    return { head: text.trim(), tail: "" };
  }
  return {
    head: text.slice(0, index).trim(),
    tail: text.slice(index).replace(pattern, "").trim(),
  };
};

const normalizeNflBio = (bio = {}) => {
  const born = splitAtLabel(bio.bornOn, "Died");
  const draft = splitAtLabel(bio.draft, "Relatives");
  return {
    ...bio,
    bornOn: born.head,
    diedOn: String(bio.diedOn || "").trim() || born.tail,
    draft: draft.head,
    relatives: String(bio.relatives || "").trim() || draft.tail,
  };
};

const getMlbBioLines = (bio = {}) =>
  [
    { label: "Born", value: formatBornLine(bio) },
    optionalLine("Died", formatDiedLine(bio)),
    { label: "Height", value: orNA(bio.height) },
    { label: "Weight", value: orNA(bio.weight) },
    { label: "Bats/Throws", value: `${orNA(bio.bats)}/${orNA(bio.throws)}` },
    { label: "MLB Debut", value: orNA(bio.firstGame) },
    { label: "Last Game", value: orNA(bio.lastGame) },
    optionalLine("High School", bio.highSchool),
    optionalLine("College", bio.college),
  ].filter(Boolean);

const getNflBioLines = (rawBio = {}) => {
  const bio = normalizeNflBio(rawBio);
  return [
    { label: "Born", value: formatBornLine(bio) },
    optionalLine("Died", formatDiedLine(bio)),
    { label: "Height", value: orNA(bio.height) },
    { label: "Weight", value: orNA(bio.weight) },
    optionalLine("Position", bio.position),
    optionalLine("Draft", bio.draft),
    optionalLine("Relatives", bio.relatives),
    optionalLine("Teams", bio.teams),
    optionalLine("High School", bio.highSchool),
    optionalLine("College", bio.college),
  ].filter(Boolean);
};

const getNbaBioLines = (bio = {}) =>
  [
    { label: "Born", value: formatBornLine(bio) },
    optionalLine("Died", formatDiedLine(bio)),
    { label: "Height", value: orNA(bio.height) },
    { label: "Weight", value: orNA(bio.weight) },
    optionalLine("Position", bio.position),
    optionalLine("Shoots", bio.shoots),
    optionalLine("Draft", bio.draft),
    optionalLine("NBA Debut", bio.nbaDebut),
    optionalLine("Experience", bio.experience),
    optionalLine("Team", bio.team),
    optionalLine("High School", bio.highSchool),
    optionalLine("College", bio.college),
  ].filter(Boolean);

export const getPlayerBioLines = (bio = {}, sport = "mlb") => {
  if (sport === "nfl") return getNflBioLines(bio);
  if (sport === "nba") return getNbaBioLines(bio);
  return getMlbBioLines(bio);
};
